/* import __COLOCATED_TEMPLATE__ from './claims-table.hbs'; */
import { humanDateFormat } from 'client-portal/utils/date-time';
import Super from './documents-table';
import styles from './claims-table.module.scss';

export default class SiteBillingClaimsTable extends Super {
  styles = styles;
  humanDateFormat = humanDateFormat;
}
